<template>
    <div class="column-layout">
        <div v-if="confKey == null">
            <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryKey="queryKey" :onConfigReady="onConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler" :eventHandler="eventHandler"></swb-query-sort-area>
            <div v-if="checkBox" class="table-layout">
                <el-table ref="multipleTable" :data="comList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" type="selection" :selectable="canSelectRow" width="55" align="center"></el-table-column>
                    <el-table-column v-if="filter != null && !filter.filterMerchantId" prop="merchantName" label="商户名称" align="left" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bizUnitName" label="业务单元" align="left" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="业务部门" align="left" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="showTag" prop="tagName" label="机构标签" align="left" width="120">
                        <template slot-scope="rows">
                            <el-tag v-if="rows.row.tagId != null" type="success">{{ rows.row.tagName }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contactName" label="联系人" align="left" width="120"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" align="center" width="110"></el-table-column>
                    <el-table-column prop="mgmtBigAreaName" label="管理大区" align="center" width="110"></el-table-column>
                    <el-table-column prop="mgmtSmlAreaName" label="管理小区" align="center" width="110"></el-table-column>
                    <el-table-column prop="bizAreaName" label="经营区域" align="center" width="110"></el-table-column>
                    <el-table-column prop="bizAreaName" label="经营区域" align="center" width="110"></el-table-column>
                    <el-table-column prop="bizFormName" label="经营业态" align="center" width="110"></el-table-column>
                    <el-table-column label="地址" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.regionName != null">{{ rows.row.regionName }}</span>
                            <span v-if="rows.row.street != null">{{ rows.row.street }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orgType" label="机构类型" align="left" width="200" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgType == 0">业务部门</span>
                            <span v-if="rows.row.orgType == 1">业务单元</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="业务单元级别" align="center" width="100">
                        <template slot-scope="rows">
                            <span>{{ getTransComLevel(rows.row.bizUnitLevel) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table ref="multipleTable" :data="comList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checkComInfo!= null && checkComInfo.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bizUnitName" label="业务单元" align="left" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="业务部门" align="left" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="showTag" prop="tagName" label="机构标签" align="left" width="110">
                        <template slot-scope="rows">
                            <el-tag v-if="rows.row.tagId != null" type="success">{{ rows.row.tagName }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contactName" label="联系人" align="center" width="110"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" align="center" width="110"></el-table-column>
                    <el-table-column prop="mgmtBigAreaName" label="管理大区" align="center" width="110"></el-table-column>
                    <el-table-column prop="mgmtSmlAreaName" label="管理小区" align="center" width="110"></el-table-column>
                    <el-table-column prop="bizAreaName" label="经营区域" align="center" width="110"></el-table-column>
                    <el-table-column prop="bizFormName" label="经营业态" align="center" width="110"></el-table-column>
                    <el-table-column label="地址" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.regionName != null">{{ rows.row.regionName }}</span>
                            <span v-if="rows.row.street != null">{{ rows.row.street }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orgType" label="机构类型" align="left" width="200" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgType == 0">业务部门</span>
                            <span v-if="rows.row.orgType == 1">业务单元</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="业务单元级别" align="center" width="100">
                        <template slot-scope="rows">
                            <span>{{ getTransComLevel(rows.row.bizUnitLevel) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
        <div v-else>
            <div name="query-sort-block">
                <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandlerForKey"></swb-query-sort-area>
            </div>
            <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect"
                              :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth"
                              :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        </div>
    </div>
</template>

<script>
import { $, Utils } from '../../app.base'
import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { openRegionForSelectDlg } from '../comn/regionSelectDlg'
import { transComLevel } from '../orgStruct/struct-comn'
import { isSysRescFrozenIsAllowed } from '../index'

import retailerApi from '../../api/retailer'
import { loadAssetKindList, loadgetRetailerBizAreaList, loadgetRetailerBizFormList, loadRetailerDevcGroupList, loadRetailerMgmtAreaList, loadShopWarehouseList } from './asset-comn';

let searchConfigData = {
    'queryFields': [{
        'type': 'Text',
        'valueType': 'String',
        'code': 'bizUnitName',
        'label': '业务单元',
        'basic': true,
        'hidden': false
    }, {
        'type': 'Text',
        'valueType': 'String',
        'code': 'name',
        'label': '业务部门',
        'basic': true,
        'hidden': false
    }, {
        'type': 'Select',
        'label': '机构标签',
        'code': 'tagId',
        'basic': true,
        'dataList': []
    }, {
        'type': 'Select',
        'valueType': 'Integer',
        'code': 'bizUnitLevel',
        'label': '业务单元级别',
        'basic': false,
        'dataList': [{
            'value': null,
            'label': '-全部-'
        }, {
            'value': '1',
            'label': '一级'
        }, {
            'value': '2',
            'label': '二级'
        }, {
            'value': '3',
            'label': '三级'
        }, {
            'value': '4',
            'label': '四级'
        }, {
            'value': '5',
            'label': '五级'
        }, {
            'value': '6',
            'label': '六级'
        }, {
            'value': '7',
            'label': '七级'
        }, {
            'value': '8',
            'label': '八级'
        }, {
            'value': '9',
            'label': '九级'
        }, {
            'value': '10',
            'label': '十级'
        }],
    }, {
        'type': 'Select',
        'valueType': 'Integer',
        'code': 'orgType',
        'label': '机构类型',
        'basic': false,
        'dataList': [{
            'value': null,
            'label': '-全部-'
        }, {
            'value': '1',
            'label': '业务单元'
        }, {
            'value': '0',
            'label': '业务部门'
        }]
    }, {
        'code': 'mgmtBigAreaIds',
        'label': '管理大区',
        'type': 'Select',
        'valueType': 'Integer',
        'value': null,
        'basic': false,
        'hidden': false,
        'rptUsed': false,
        'ctxBindName': null,
        'dataList': [],
        'multiple': true
    }, {
        'code': 'mgmtSmlAreaIds',
        'label': '管理小区',
        'type': 'Select',
        'valueType': 'Integer',
        'value': null,
        'basic': false,
        'hidden': false,
        'rptUsed': false,
        'ctxBindName': null,
        'dataList': [],
        'multiple': true
    }, {
        'code': 'bizAreaIds',
        'label': '经营区域',
        'type': 'Select',
        'valueType': 'Integer',
        'value': null,
        'basic': false,
        'hidden': false,
        'rptUsed': false,
        'ctxBindName': null,
        'dataList': [],
        'multiple': true
    }, {
        'code': 'bizFormIds',
        'label': '经营业态',
        'type': 'Select',
        'valueType': 'Integer',
        'value': null,
        'basic': false,
        'hidden': false,
        'rptUsed': false,
        'ctxBindName': null,
        'dataList': [],
        'multiple': true
    }, {
        'type': 'Popup',
        'valueType': 'Integer',
        'label': '地区',
        'code': 'regionId',
        'basic': true
    }],
    'sortFields': []
};

export default {
    name: 'swb-retailer-com-list-for-select',
    desc: '零售商机构-选择',
    props: {
        confKey: {
            type: String,
            default: null
        },
        checkBox: {
            type: Boolean,
            default: true
        },
        isCom: {
            type: Boolean,
            default: false
        },
        filter: {
            type: Object,
            default: function () {
                return {};
            }
        },
        checkedComList: {// 多选的时候传入
            type: Array,
            default: function () {
                return [];
            }
        },
        disabledIds: {
            type: Array,
            default: function () {
                return [];
            }
        },
        states: {
            type: Array,
            default: function () {
                return [1, 3];
            }
        }
    },
    data: function () {
        return {
            theTableHeight: 550,
            queryOnLoad: true,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）
            btnColName: null,//操作列名称（如果不设置就不显示操作列）
            //
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 200,//操作列宽度（默认：100）
            //
            btnColFixed: false, //操作列是否固定
            resultColConf: {//不想要列配置设置 = null即可
                metaColList: []
            },
            //
            pageNumber: 1,
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            //
            checkedTblRefId: 'multipleTable',
            checkedDelay: 100,
            checkedIniting: false,
            //
            comList: [],
            name: null,
            selectComList: [],
            selectComIds: [],
            checkComInfo: null,
            //
            //排序、搜索
            queryConfig: {},
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            provinceId: null,
            cityId: null,
            countyId: null,
            showTag: true
        }
    },
    created: function () {
        let self = this;
        this.pageSize = this.pageSizes.first();
        this.selectComList = Utils.merge([], this.checkedComList);
        //
        let queryConfig = searchConfigData || {};
        if(!Utils.isNoB(this.filter) && Utils.isFalse(this.filter.filterMerchantId)) {
            let queryFields = [{
                'type': 'Text',
                'valueType': 'String',
                'code': 'merchantName',
                'label': '商户名称',
                'basic': true,
                'hidden': false
            }];
            queryFields = queryFields.concat(searchConfigData.queryFields);
            searchConfigData.queryFields = Utils.merge([], queryFields);
            queryConfig = Utils.merge({}, searchConfigData);
        }
        let queryConfigMap = queryConfig.queryFields.toMap('code');
        if(!Utils.isNoB(this.filter.orgType)) {
            // 不为空的时候隐藏机构类型条件搜索
            let orgTypeItem = queryConfigMap['orgType'];
            orgTypeItem.hidden = true;
        }
        if(Utils.isNoB(this.filter.merchantId)) {
            this.getRetailerShopTagList(function (tagList) {
                let tagItem = queryConfigMap['tagId'];
                tagItem.dataList = [];
                tagItem.dataList = Utils.merge([], tagList);
                self.queryConfig = Utils.merge({}, queryConfig);
            });
        } else {
            let tagItem = queryConfigMap['tagId'];
            tagItem.hidden = true;
            self.queryConfig = Utils.merge({}, queryConfig);
            this.showTag = false;
        }
        //
        if(this.confKey == null) {
            this.getRetailerComList();
        }
    },
    mounted() {
        if(this.confKey != null) {
            this.initResultTable();
        }
    },
    destroyed() {
    },
    methods: {
        onConfigReady() {
            let self = this;
            // 加载管理大区
            loadRetailerMgmtAreaList(true, function (dataList) {
                self.updateQueryModelField('mgmtBigAreaIds', dataList);
            });
            // 加载管理小区
            loadRetailerMgmtAreaList(false, function (dataList) {
                self.updateQueryModelField('mgmtSmlAreaIds', dataList);
            });
            // 区域
            loadgetRetailerBizAreaList(function (dataList) {
                self.updateQueryModelField('bizAreaIds', dataList);
            });
            // 业态
            loadgetRetailerBizFormList(function (dataList) {
                self.updateQueryModelField('bizFormIds', dataList);
            });
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if(itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {
                    dataList: dataList
                };
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        getTransComLevel: function (level) {
            return transComLevel(level);
        },
        queryHandler(queryModel) {
            if(this.checkedIniting) {
                return;
            } else {
                this.checkedIniting = true;
            }
            this.pageNumber = 1;
            this.queryModel = queryModel;
            //
            this.getRetailerComList();
        },
        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            if(this.checkedIniting) {
                return;
            } else {
                this.checkedIniting = true;
            }
            this.pageNumber = val;
            this.getRetailerComList();
        },
        // 根据不同信息变换查询信息
        popupHandler: function (fieldCode, curValue, curText) {
            let self = this;
            if(fieldCode == 'regionId') {
                let params = {
                    provinceId: self.provinceId,
                    cityId: self.cityId,
                    countyId: self.countyId,
                };
                openRegionForSelectDlg(params, function (result) {
                    let query_model_ctrl = self.$refs['query_model_ctrl'];
                    let fieldInfo = {
                        regionId: {
                            value: result.regionId,
                            text: result.regionName
                        }
                    };
                    query_model_ctrl.updateFields(fieldInfo);
                    self.provinceId = result.provinceId;
                    self.cityId = result.cityId;
                    self.countyId = result.countyId;
                });
            }
        },
        eventHandler: function (itemCode, eventName, itemValue) {
            let queryFields = this.queryConfig.queryFields;
            if(eventName == 'change') {
                //
                if(itemCode == 'regionId' && Utils.isNoB(itemValue)) {
                    let regionItem = queryFields.find(function (field) {
                        return field.code == 'regionId';
                    });
                    //
                    regionItem.forcedValue = null;
                    regionItem.text = null;
                    this.provinceId = null;
                    this.cityId = null;
                    this.countyId = null;
                    //
                    this.queryConfig = Utils.merge({}, this.queryConfig);
                }
            }
        },
        //
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'mgmtSmlAreaNames': function (row, colName, colValue, rowIndex, btnName) {
                    if(Utils.isNoB(row.mgmtBigAreaName) && Utils.isNoB(row.mgmtSmlAreaName)) {
                        return '';
                    } else {
                        return (row.mgmtBigAreaName || '') + '/' + (row.mgmtSmlAreaName || '');
                    }
                },
                'actions': function (row, colName, colValue, rowIndex) {
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                }
            });
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        queryHandlerForKey: function (data) {
            this.queryModel = data;
            this.pageNumber = 1;
            this.getRetailerComList();
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);

            let resultTable = this.$refs.result_table;
            console.log(resultTable.getPagination());

            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getRetailerComList();
        },
        getRetailerComList: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            let filter = self.filter || {};
            filterItems.shopFlag = filter.shopFlag;
            filterItems.bizUnitType = filter.bizUnitType;
            filterItems.bizUnitShopFlag = filter.bizUnitShopFlag;
            filterItems.merchantId = filter.merchantId;
            if(!Utils.isNoB(filter.bizAreaIds) && filter.bizAreaIds.length > 0) {
                filterItems.bizAreaIds = filter.bizAreaIds;
            }
            if(!Utils.isNoB(filter.comId)) {
                filterItems.comId = filter.comId;
            }
            if(!Utils.isNoB(filter.comLevel)) {
                filterItems.comLevel = filter.comLevel;
            }
            if(!Utils.isNoB(filter.bizUnitLevels) && filter.bizUnitLevels.length > 0) {
                filterItems.bizUnitLevels = filter.bizUnitLevels;
            }
            if(!Utils.isNoB(filter.bizFormIds) && filter.bizFormIds.length > 0) {
                filterItems.bizFormIds = filter.bizFormIds;
            }
            if(!Utils.isNoB(filter.ids) && filter.ids.length > 0) {
                filterItems.ids = filter.ids;
            }
            if(!Utils.isNoB(filter.bizUnitId)) {
                filterItems.bizUnitId = filter.bizUnitId;
            }
            if(!Utils.isNoB(filter.orgType)) {
                filterItems.orgType = filter.orgType;
            }
            if(Utils.isTrue(self.isCom)) {
                filterItems.isCom = self.isCom;
            }
            if(!Utils.isNoB(filter.realComId)) {
                filterItems.realComId = filter.realComId;
                filterItems.queryByRealCom = true;
            }
            if(!Utils.isNoB(filter.signGroupId)) {
                filterItems.signGroupId = filter.signGroupId;
            }
            filterItems.states = this.states;
            if(!Utils.isNoB(filterItems.regionId)) {
                filterItems.regionId = null;
                //
                filterItems.provinceId = self.provinceId;
                filterItems.cityId = self.cityId;
                filterItems.countyId = self.countyId;
            }
            filterItems.filterMerchantId = filter.filterMerchantId;
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            let theLoad = MsgBox.loading();
            retailerApi.getRetailerShopListByMerchantId(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let data = result.data;
                    self.comList = data.rows;
                    //
                    if(Utils.isNoB(self.confKey)) {
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        // 处理回显
                        setTimeout(function () {
                            self.restoreSelRows(self.comList, self.checkedTblRefId, 'id');
                        }, self.checkedDelay);
                    } else {
                        let pagination = result.data.pagination;
                        self.renderTable(self.comList, pagination);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        restoreSelRows(dataRows, tblRefId, idProp) {
            let self = this;
            self.checkedIniting = true;
            idProp = idProp || 'id';
            let allIds = dataRows.pluck(idProp);
            let selectComIds = self.selectComList.pluck('id');
            let selIds = Utils.compareArrays(allIds, selectComIds)['same'];
            selIds.forEach(function (id) {
                self.toggleListRowById(dataRows, tblRefId, idProp, id);
            });
            //
            self.checkedIniting = false
        },
        toggleListRowById(dataRows, tblRefId, idProp, idVal) {
            let self = this;
            idProp = idProp || 'id';
            let refTbl = self.$refs[tblRefId];
            let theRow = dataRows.find(function (row, idx) {
                return row[idProp] == idVal;
            });
            if(theRow != null) {
                refTbl.toggleRowSelection(theRow);
            }
        },
        // 多选
        handleSelectionChange: function (selRows) {
            let self = this;
            if(self.checkedIniting) {
                return;
            }
            let selectComIds = self.selectComList.pluck('id');
            let selectIds = Utils.merge([], selectComIds);
            let selectComList = Utils.merge([], this.selectComList);
            //
            let allIds = self.comList.pluck('id');
            let selIds = selRows.pluck('id');
            selIds.forEach(function (id, index) {
                self.addCheckId(id, selRows[index], selectIds, selectComList);
            });
            let lesIds = Utils.compareArrays(selIds, allIds)['less'];
            lesIds.forEach(function (id, index) {
                self.delCheckId(id, selectIds, selectComList);
            });
            //
            this.$emit('handle-change', selectComList);
            this.selectComList = selectComList;
        },
        addCheckId: function (id, val, checkedIds, checkedList) {
            if(!checkedIds.contains(id)) {
                checkedIds.add(id);
                checkedList.add(val);
                return id;
            }
            this.$emit('handle-change', checkedList);
            return null;
        },
        delCheckId: function (id, checkedIds, checkedList) {
            if(checkedIds.contains(id)) {
                for(let i = 0; i < checkedList.length; i++) {
                    let checkedCom = checkedList[i];
                    if(checkedCom.id == id) {
                        checkedList.splice(i, 1);
                    }
                }
                checkedIds.remove(id);
                return id;
            }
            this.$emit('handle-change', checkedList);
            return null;
        },
        // 单选
        handleCurrentChange: function (val) {
            this.checkComInfo = Utils.merge({}, val);
        },
        getRetailerShopTagList: function (callback) {
            let loading = MsgBox.loading();
            retailerApi.getRetailerShopTagListByContext({}, function (result) {
                loading.close();
                if(result.type == 'info') {
                    let retailerShopTagList = result.data;
                    let showTagList = [];
                    if(!Utils.isNoB(retailerShopTagList) && retailerShopTagList.length > 0) {
                        retailerShopTagList.forEach(function (item) {
                            showTagList.push({
                                value: item.id,
                                label: item.name
                            });
                        });
                    }
                    callback(showTagList);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        getDlgResult: function () {
            let self = this;
            let result = {};
            //
            let checkBox = this.checkBox;
            if(checkBox) {

                let selectComList = self.selectComList;
                if(selectComList != null && selectComList.length > 0) {
                    selectComList.forEach(function (item) {
                        let isAllowed = isSysRescFrozenIsAllowed(self, item);
                        if(!isAllowed) {
                            result.type = 'warn';
                            result.message = '当前选择的机构【' + item.name + '】该业务已冻结，请重新选择！';
                            return result;
                        }
                    });
                    result.type = 'info';
                    result.data = selectComList;
                } else {
                    result.type = 'warn';
                    result.message = '至少选择一个机构！';
                }
            } else {
                let comInfo = self.checkComInfo;
                if(comInfo != null) {
                    let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
                    if(!isAllowed) {
                        result.type = 'warn';
                        result.message = '当前选择的机构【' + comInfo.name + '】该业务已冻结，请重新选择！';
                        return result;
                    }
                    result.type = 'info';
                    result.data = comInfo;
                } else {
                    result.type = 'warn';
                    result.message = '请选择机构！';
                }
            }
            return result;
        },
        getDlgResultForKey: function () {
            let result = {
                type: 'info'
            };
            let comList = this.getTableSelection() || [];
            if(comList.length <= 0) {
                result.type = 'warn';
                result.message = '至少选择一个机构！';
            } else {
                comList.forEach(function (item) {
                    let isAllowed = isSysRescFrozenIsAllowed(self, item);
                    if(!isAllowed) {
                        result.type = 'warn';
                        result.message = '当前选择的机构【' + item.name + '】该业务已冻结，请重新选择！';
                        return result;
                    }
                });
                result.data = comList;
            }
            return result;
        },
        canSelectRow(row, index) {
            return !this.disabledIds.contains(row.id);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerComListForSelect.vue